import React from 'react';
import { Box, Typography } from '@mui/material';

import { calculateFloorPolyline2DShape } from '@paragon/layout';

import {
  finishInsertingFeaturePatternContainer,
  getFeaturePatternContainerPatch,
} from '../../../../store/actions/layout/featurePatternContainerActions';
import { getAllBearingEnvelopesDictionary } from '../../../../store/selectors/layoutDataSelectors';
import { updateInsertionFeaturePatternContainer } from '../../../../store/slices/applicationSlice';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { FeaturePatternContainerPropertyControls } from '../properties/FeaturePatternContainerPropertyControls';
import InsertionPanelContainer from './InsertionPanelContainer';

export function FeaturePatternContainerInsertionSubPanel() {
  const dispatch = useAppDispatch();

  const bearingEnvelopes = useAppSelector(getAllBearingEnvelopesDictionary);
  const insertingObjectInfo = useAppSelector((state) => state.application.insertingObjectInfo);

  if (insertingObjectInfo?.type !== 'featurePatternContainer') return null;

  const insertionContainer = insertingObjectInfo.data;

  const boundedContainer = calculateFloorPolyline2DShape(insertionContainer.shape, bearingEnvelopes);
  const readyToInsert = boundedContainer != null;

  return (
    <InsertionPanelContainer
      disabled={!readyToInsert}
      onInsert={() => {
        dispatch(finishInsertingFeaturePatternContainer());
      }}
    >
      <Box sx={{ p: 1, mb: 2 }} className="clickable-during-picking">
        <Typography align="center" variant="h5" sx={{ marginBottom: 3 }}>
          Feature Pattern Container
        </Typography>

        <FeaturePatternContainerPropertyControls
          // FIXME until layout line picking transitions to the new picking system, choosing an edge to slope the
          // insertion container from is broken.
          hideSlopeControls
          value={insertionContainer}
          onChange={(changes) => {
            const patch = getFeaturePatternContainerPatch(changes, insertionContainer);
            dispatch(updateInsertionFeaturePatternContainer(patch));
          }}
        />
      </Box>
    </InsertionPanelContainer>
  );
}
